var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBackBreadcrumb(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.19 0H5.81C2.17 0 0 2.17 0 5.81V14.18C0 17.83 2.17 20 5.81 20H14.18C17.82 20 19.99 17.83 19.99 14.19V5.81C20 2.17 17.83 0 14.19 0ZM16 10.75H5.81L8.82 13.76C9.11 14.05 9.11 14.53 8.82 14.82C8.67 14.97 8.48 15.04 8.29 15.04C8.1 15.04 7.91 14.97 7.76 14.82L3.47 10.53C3.33 10.39 3.25 10.2 3.25 10C3.25 9.8 3.33 9.61 3.47 9.47L7.76 5.18C8.05 4.89 8.53 4.89 8.82 5.18C9.11 5.47 9.11 5.95 8.82 6.24L5.81 9.25H16C16.41 9.25 16.75 9.59 16.75 10C16.75 10.41 16.41 10.75 16 10.75Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackBreadcrumb);
export default __webpack_public_path__ + "static/media/back-breadcrumb.96fb81ede730aa92076091c38100e083.svg";
export { ForwardRef as ReactComponent };